"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Team = void 0;

var React = _interopRequireWildcard(require("react"));

var _blocks = require("@bueno/blocks");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _core = require("@lingui/core");

const TeamWrapper = _styledComponents.default.section`
  display: grid;
  gap: ${_blocks.spacing.default};
`;
const AddAssigneeWrap = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
`;
const AddButton = (0, _styledComponents.default)(_blocks.Button)`
  box-sizing: content-box;
  text-align: left;
  gap: ${_blocks.spacing.extraTight};
  font-size: 13px;
`;
const SubduedLabel = (0, _styledComponents.default)(_blocks.BodySmall)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: ${_blocks.spacing.loose};
  color: ${_blocks.color.theme.typography.subdued};
  margin-bottom: ${_blocks.spacing.extraTight};
`;
const Select = (0, _styledComponents.default)(_blocks.FieldSelect)`
  margin-bottom: 0;

  label {
    color: ${_blocks.color.theme.typography.subdued};
  }

  .BuenoBazaarSelect__single-value.BuenoBazaarSelect__single-value {
    overflow: hidden;
    max-width: calc(100% - 40px);
    height: 24px;
    line-height: 24px;
  }

  // Menu when open
  .BuenoBazaarSelect__menu.BuenoBazaarSelect__menu {
    z-index: 2;
  }
`;

const Team = ({
  team,
  teamOptions,
  assignee,
  assigneeOptions,
  editFn
}) => {
  const [canAddAssignee, setCanAddAssignee] = React.useState(assignee === undefined);

  const handleAssigneeRemoval = () => {
    if (assignee !== undefined) {
      // eslint-disable-next-line no-void
      void editFn({
        assignee: ''
      })();
    }

    setCanAddAssignee(true);
  };

  return /*#__PURE__*/React.createElement(TeamWrapper, null, teamOptions !== undefined && /*#__PURE__*/React.createElement(Select, {
    thin: true,
    name: "responsible",
    options: teamOptions,
    label: /*#__PURE__*/React.createElement(SubduedLabel, null, _core.i18n._({
      id: 'inline_edit.team_label',
      message: `Team`
    })),
    value: team != null && team !== '' ? {
      label: team,
      value: team
    } : undefined,
    onChange: option => {
      option != null && 'value' in option && editFn({
        responsible: `${option.value}`
      })();
    }
  }), assigneeOptions !== undefined && canAddAssignee && /*#__PURE__*/React.createElement(AddAssigneeWrap, null, /*#__PURE__*/React.createElement(SubduedLabel, null, _core.i18n._({
    id: 'inline_edit.assignee_label',
    message: `Assignee`
  })), /*#__PURE__*/React.createElement(AddButton, {
    thin: true,
    primary: true,
    appearance: "plain",
    icon: /*#__PURE__*/React.createElement(_blocks.Plus, {
      tiny: true
    }),
    onClick: () => setCanAddAssignee(false)
  }, _core.i18n._({
    id: 'inline_edit.add_assignee',
    message: `Add Assignee`
  }))), assigneeOptions !== undefined && !canAddAssignee && /*#__PURE__*/React.createElement(Select, {
    thin: true,
    name: "assignee",
    options: assigneeOptions,
    label: /*#__PURE__*/React.createElement(SubduedLabel, null, _core.i18n._({
      id: 'inline_edit.assignee_label',
      message: `Assignee`
    }), /*#__PURE__*/React.createElement(_blocks.Button, {
      wafer: true,
      destructive: true,
      appearance: "plain",
      onClick: handleAssigneeRemoval
    }, _core.i18n._({
      id: 'inline_edit.v2.remove_assignee',
      message: `Remove`
    }))),
    value: assignee != null && assignee !== '' ? {
      label: assignee,
      value: assignee
    } : undefined,
    onChange: option => {
      option != null && 'value' in option && editFn({
        assignee: `${option.value}`
      })();
    }
  }));
};

exports.Team = Team;